module.exports = __webpack_public_path__ + "img/fund_img1.33e7a6a2.png";